export const isBetween = (value, min, max) => {
  return value >= min && value <= max;
};
export const isInt = num => {
  return Number(num) === num && num % 1 === 0;
};
export const isFloat = num => {
  return Number(num) === num && num % 1 !== 0;
};
export const parseMinMax = (min, max) => {
  return [Math.min(min, max), Math.max(min, max)];
};
export const parseValueBetween = (value, min, max) => {
  const isInteger = Number.isInteger(value);
  if (!isInteger) return min;
  if (isBetween(value, min, max)) return value;
  if (value < min) return min;
  if (value > max) return max;
  return value;
};
export const parseValuesBetween = (value, min, max) => {
  const isArray = Array.isArray(value);
  if (!isArray) return [min, max];
  if (isBetween(value[0], min, max) && isBetween(value[1], min, max)) return value;
  const valueMin = value[0] < min ? min : value[0];
  const valueMax = value[1] > max ? max : value[1];
  return [valueMin, valueMax];
};
export const percentTrack = (value, min, max) => (value - min) / (max - min) * 100;